// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"e7cc87c2","381":"7c8267fd","414":"ca8d1d2e","756":"d8e78ecb"}[chunkId] + ".chunk.js";
};